/**
 * A map from Mixamo rig name to VRM Humanoid bone name
 */
export const normalizedVRMRigMap = {
    Hips: 'hips',
    Spine: 'spine',
    Spine1: 'chest',
    Spine2: 'upperChest',
    Neck: 'neck',
    Head: 'head',
    LeftShoulder: 'leftShoulder',
    LeftArm: 'leftUpperArm',
    LeftForeArm: 'leftLowerArm',
    LeftHand: 'leftHand',
    LeftHandThumb1: 'leftThumbMetacarpal',
    LeftHandThumb2: 'leftThumbProximal',
    LeftHandThumb3: 'leftThumbDistal',
    LeftHandIndex1: 'leftIndexProximal',
    LeftHandIndex2: 'leftIndexIntermediate',
    LeftHandIndex3: 'leftIndexDistal',
    LeftHandMiddle1: 'leftMiddleProximal',
    LeftHandMiddle2: 'leftMiddleIntermediate',
    LeftHandMiddle3: 'leftMiddleDistal',
    LeftHandRing1: 'leftRingProximal',
    LeftHandRing2: 'leftRingIntermediate',
    LeftHandRing3: 'leftRingDistal',
    LeftHandPinky1: 'leftLittleProximal',
    LeftHandPinky2: 'leftLittleIntermediate',
    LeftHandPinky3: 'leftLittleDistal',
    RightShoulder: 'rightShoulder',
    RightArm: 'rightUpperArm',
    RightForeArm: 'rightLowerArm',
    RightHand: 'rightHand',
    RightHandPinky1: 'rightLittleProximal',
    RightHandPinky2: 'rightLittleIntermediate',
    RightHandPinky3: 'rightLittleDistal',
    RightHandRing1: 'rightRingProximal',
    RightHandRing2: 'rightRingIntermediate',
    RightHandRing3: 'rightRingDistal',
    RightHandMiddle1: 'rightMiddleProximal',
    RightHandMiddle2: 'rightMiddleIntermediate',
    RightHandMiddle3: 'rightMiddleDistal',
    RightHandIndex1: 'rightIndexProximal',
    RightHandIndex2: 'rightIndexIntermediate',
    RightHandIndex3: 'rightIndexDistal',
    RightHandThumb1: 'rightThumbMetacarpal',
    RightHandThumb2: 'rightThumbProximal',
    RightHandThumb3: 'rightThumbDistal',
    LeftUpLeg: 'leftUpperLeg',
    LeftLeg: 'leftLowerLeg',
    LeftFoot: 'leftFoot',
    LeftToeBase: 'leftToes',
    RightUpLeg: 'rightUpperLeg',
    RightLeg: 'rightLowerLeg',
    RightFoot: 'rightFoot',
    RightToeBase: 'rightToes',
};

/**
 * A map from Mixamo rig name to VRM Humanoid bone name
 */
export const mixamoVRMRigMap = {
    mixamorigHips: "hips",
    mixamorigSpine: "spine",
    mixamorigSpine1: "chest",
    mixamorigSpine2: "upperChest",
    mixamorigNeck: "neck",
    mixamorigHead: "head",
    mixamorigLeftShoulder: "leftShoulder",
    mixamorigLeftArm: "leftUpperArm",
    mixamorigLeftForeArm: "leftLowerArm",
    mixamorigLeftHand: "leftHand",
    mixamorigLeftHandThumb1: "leftThumbMetacarpal",
    mixamorigLeftHandThumb2: "leftThumbProximal",
    mixamorigLeftHandThumb3: "leftThumbDistal",
    mixamorigLeftHandIndex1: "leftIndexProximal",
    mixamorigLeftHandIndex2: "leftIndexIntermediate",
    mixamorigLeftHandIndex3: "leftIndexDistal",
    mixamorigLeftHandMiddle1: "leftMiddleProximal",
    mixamorigLeftHandMiddle2: "leftMiddleIntermediate",
    mixamorigLeftHandMiddle3: "leftMiddleDistal",
    mixamorigLeftHandRing1: "leftRingProximal",
    mixamorigLeftHandRing2: "leftRingIntermediate",
    mixamorigLeftHandRing3: "leftRingDistal",
    mixamorigLeftHandPinky1: "leftLittleProximal",
    mixamorigLeftHandPinky2: "leftLittleIntermediate",
    mixamorigLeftHandPinky3: "leftLittleDistal",
    mixamorigRightShoulder: "rightShoulder",
    mixamorigRightArm: "rightUpperArm",
    mixamorigRightForeArm: "rightLowerArm",
    mixamorigRightHand: "rightHand",
    mixamorigRightHandPinky1: "rightLittleProximal",
    mixamorigRightHandPinky2: "rightLittleIntermediate",
    mixamorigRightHandPinky3: "rightLittleDistal",
    mixamorigRightHandRing1: "rightRingProximal",
    mixamorigRightHandRing2: "rightRingIntermediate",
    mixamorigRightHandRing3: "rightRingDistal",
    mixamorigRightHandMiddle1: "rightMiddleProximal",
    mixamorigRightHandMiddle2: "rightMiddleIntermediate",
    mixamorigRightHandMiddle3: "rightMiddleDistal",
    mixamorigRightHandIndex1: "rightIndexProximal",
    mixamorigRightHandIndex2: "rightIndexIntermediate",
    mixamorigRightHandIndex3: "rightIndexDistal",
    mixamorigRightHandThumb1: "rightThumbMetacarpal",
    mixamorigRightHandThumb2: "rightThumbProximal",
    mixamorigRightHandThumb3: "rightThumbDistal",
    mixamorigLeftUpLeg: "leftUpperLeg",
    mixamorigLeftLeg: "leftLowerLeg",
    mixamorigLeftFoot: "leftFoot",
    mixamorigLeftToeBase: "leftToes",
    mixamorigRightUpLeg: "rightUpperLeg",
    mixamorigRightLeg: "rightLowerLeg",
    mixamorigRightFoot: "rightFoot",
    mixamorigRightToeBase: "rightToes",
};
